import { selectEncryptedJourneyId, useQuoteStore } from '../../../stores';

export const useEncryptedJourneyId = () => {
	const encryptedJourneyId = useQuoteStore(selectEncryptedJourneyId);

	return { encryptedJourneyId };
};
